<template>
  <div>
    <vxe-grid
      ref="table"
      size="small"
      row-id="hxJdOrderCode"
      border
      auto-resize
      resizable
      highlight-hover-row
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
    >
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
          >
            <i class="el-icon-delete tool-btn" @click="del(row)" />
          </el-tooltip>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import tableColumns from './order-table-columns'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    disabled: { type: Boolean, default: false },
    hxJdVehicleCode: { type: String, default: '' },
    hxShipmentJdCode: { type: String, default: '' },
  },
  data() {
    return {
      tableData: [],
      loading: false,
      tableColumns: tableColumns(this),
    }
  },
  async mounted() {
    await this.getData()
  },
  methods: {
    async getData() {
      if (!this.hxShipmentJdCode) return
      this.loading = true
      const res = await this.$api
        .ecomHxShipmentJdOrderListApi({
          hxJdVehicleCode: this.hxJdVehicleCode,
          hxShipmentJdCode: this.hxShipmentJdCode,
        })
        .catch(() => null)
      this.loading = false
      this.tableData = res?.body?.data || []
    },
    async del({ hxJdOrderCode }) {
      const confirm = await this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      if (this.loadingOpen()) return

      const res = await this.$api
        .ecomHxShipmentJdOrderRemoveVehicleApi({ hxJdOrderCode })
        .catch(() => false)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_delete_no') || '删除失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
        type: 'success',
      })
      this.getData()
      this.$emit('reload')
    },
  },
}
</script>
